import { render, staticRenderFns } from "./AddBlackDialog.vue?vue&type=template&id=65887b42&scoped=true&"
import script from "./AddBlackDialog.vue?vue&type=script&lang=js&"
export * from "./AddBlackDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65887b42",
  null
  
)

export default component.exports